"use client";

import { MaintenancePreviewBanner } from "@/components/MaintenancePreviewBanner";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

type Props = {
  header: ReactNode;
  footer: ReactNode;
  widgets?: ReactNode;
  showMaintenancePreview?: boolean;
  children: React.ReactNode;
};

export function SiteChrome({
  header,
  footer,
  widgets,
  showMaintenancePreview = false,
  children,
}: Props) {
  const pathname = usePathname();
  const isMaintenance =
    pathname === "/maintenance" || pathname?.startsWith("/maintenance/");

  if (isMaintenance) {
    return <>{children}</>;
  }

  return (
    <>
      {showMaintenancePreview ? <MaintenancePreviewBanner /> : null}
      {header}
      <main id="main-content" className="flex-1 min-w-0 overflow-x-clip" tabIndex={-1}>
        {children}
      </main>
      {footer}
      {widgets}
    </>
  );
}
